import { AxiosRequestConfig, AxiosError } from 'axios';
import axios from 'axios';
import repository from '@/repositories/repository';
import { useUserStore } from '@/store/user';
import { ERROR_CODE } from '@/const/errorCode';

import AuthRepository from '@/repositories/authRepository';
import MasterRepository from '@/repositories/masterRepository';
import PurchaseRepository from '@/repositories/purchaseRepository';
import CompanyRepository from '@/repositories/companyRepository';
import FileRepository from '@/repositories/fileRepository';


export interface Repositories {
    auth: AuthRepository;
    master: MasterRepository;
    purchase: PurchaseRepository;
    company: CompanyRepository;
    file: FileRepository;
}

/**
 * ���|�W�g���擾
 * @return Repositories
 */
function getRepositories(): Repositories {
    
    // ���N�G�X�g���̋��ʏ���
    repository.interceptors.request.use(requestIntercept);

    // ���X�|���X���̋��ʏ���
    repository.interceptors.response.use(
        response => response,
        responseErrorIntercept
    );

    // �eAPI���|�W�g�����C���X�^���X��
    const auth = new AuthRepository(repository);
    const master = new MasterRepository(repository);
    const purchase = new PurchaseRepository(repository);
    const company = new CompanyRepository(repository);
    const file = new FileRepository(repository);

    const repositories: Repositories = {
        auth,
        master,
        purchase,
        company,
        file
    };
    return repositories;
}

/**
 * ���N�G�X�g���̃C���^�[�Z�v�g
 * @param {AxiosRequestConfig} request
 * @return AxiosRequestConfig
 */
function requestIntercept(request: AxiosRequestConfig): AxiosRequestConfig {
    const store = useUserStore();
    
    // �g�[�N���ݒ�
    if (store.token) {
        request.headers!.authorization = `Bearer ${store.token}`;
    }
    
    return request;
}

/**
 * ���X�|���X���̃C���^�[�Z�v�g�i�G���[���j
 * @param {any} error
 * @throws {Promise<any>} Error
 */
async function responseErrorIntercept(error: any): Promise<any> {
    console.log("API call error");

    if (axios.isAxiosError(error)) {
        // AxiosError�̏ꍇ

        // responseType��blob�������ꍇ�A�G���[�R�[�h�������o���čăZ�b�g
        if (error.request.responseType === 'blob' &&
            error.response?.data instanceof Blob &&
            error.response.data.type &&
            error.response.data.type.toLowerCase().indexOf('json') != -1
        ) {
            error.response.data = JSON.parse(await error.response.data.text());
        }

        const errorResponse = (error as AxiosError<ErrorType.ApiErrorResponse>).response?.data;
        const message = errorResponse ? errorResponse.title : error.message;
        console.log("status:" + error.response?.status);
        console.log("error code:" + errorResponse?.code);
        console.log("message:" + message);

        // �F�ؐ؂�̂��߃��O�A�E�g���{
        if (errorResponse?.code == ERROR_CODE.TOKEN_INVALID) {
            // ���O�A�E�g�������{
            useUserStore().expired();
            // ���O�C����ʂ֑J�ځi�����I�ɍēǍ��j
            window.location.href = '/Login';
        }

    } else if (error instanceof Error) {
        // Error�̏ꍇ
        console.log(error.message);
    } else {
        // ���̑��G���[�̏ꍇ
        console.log("unexpected error");
        console.log(error);
    }
    return Promise.reject(error);
}

export default getRepositories();